import {ChangeDetectionStrategy, ChangeDetectorRef, Component, signal} from '@angular/core'
import {JobRequestContactPageComponent} from './job-request-contact-page/job-request-contact-page.component'
import {JobRequestDetailPageComponent} from './job-request-detail-page/job-request-detail-page.component'
import {JobRequestExecutionDetailsPageComponent} from './job-request-execution-details-page/job-request-execution-details-page.component'
import {JobRequestSummaryPageComponent} from './job-request-summary-page/job-request-summary-page.component'
import {BackgroundColour, OptableLayout} from '../../../core/components/layout/optable-layout.interface'
import {faPaperPlane} from '@fortawesome/pro-solid-svg-icons/faPaperPlane'
import {faPencilAlt} from '@fortawesome/pro-solid-svg-icons/faPencilAlt'
import {faUser} from '@fortawesome/pro-solid-svg-icons/faUser'
import {AgencyResolved} from './resolvers/job-request-agency.resolver'
import {ActivatedRoute} from '@angular/router'
import {PageComponent, PageMetadata} from '../../../core/seo/page-metadata'
import {Observable, of} from 'rxjs'
import {JobRequestIntentionComponent} from './job-request-intention/job-request-intention.component'
import {LayoutService} from '../../../core/components/layout/layout.service'
import {JobRequestClientExpectationPageComponent} from './job-request-client-expectation-page/job-request-client-expectation-page.component'
import {Logger} from '../../../core/logging/logger.types'
import {JobRequestService} from './job-request.service'
import {StepperPosition} from '../../../shared/components/process-navbar/process-navbar.component'

@Component({
  templateUrl: './job-request-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {ngSkipHydration: 'true'},
  standalone: false,
})
export class JobRequestPageComponent extends PageComponent implements OptableLayout {
  currentStep = signal(0)
  showStepper = signal<StepperPosition>('hidden')
  private readonly jobRequestWizardStepMapping: {
    component: new (...args: unknown[]) => unknown
    step: number
    showStepper: StepperPosition
  }[] = [
    {component: JobRequestIntentionComponent, step: 0, showStepper: 'hidden'},
    {component: JobRequestClientExpectationPageComponent, step: 0, showStepper: 'hidden'},
    {component: JobRequestDetailPageComponent, step: 1, showStepper: 'hidden'},
    {component: JobRequestExecutionDetailsPageComponent, step: 1, showStepper: 'auto'},
    {component: JobRequestContactPageComponent, step: 2, showStepper: 'auto'},
    {component: JobRequestSummaryPageComponent, step: 3, showStepper: 'auto'},
  ]
  readonly pencilIcon = faPencilAlt
  readonly contactIcon = faUser
  readonly sendIcon = faPaperPlane
  readonly agency?: AgencyResolved = this.route.snapshot.data['agency']

  hideNavbar = true
  hideFooter = true
  optOutOfLayout = true
  backgroundColour: BackgroundColour = 'blue'

  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly route: ActivatedRoute,
    private readonly layoutService: LayoutService,
    private readonly logger: Logger,
    protected readonly jobRequestService: JobRequestService,
  ) {
    super()
  }

  getPageMetadata(): Observable<PageMetadata> {
    return of({
      doNotIndexPage: true,
    })
  }

  onRouteActivated(
    component:
      | JobRequestDetailPageComponent
      | JobRequestExecutionDetailsPageComponent
      | JobRequestContactPageComponent
      | JobRequestSummaryPageComponent
      | JobRequestClientExpectationPageComponent
      | unknown,
  ): void {
    const stepMap = this.jobRequestWizardStepMapping.find(x => component instanceof x.component)

    if (!stepMap) {
      this.logger.error('No step is mapped for current component', {component})
      return
    }

    if (stepMap.step === 0) {
      this.backgroundColour = 'blue'
    } else {
      this.backgroundColour = 'default'
    }

    this.currentStep.set(stepMap.step)
    this.showStepper.set(stepMap.showStepper)

    this.cdr.detectChanges()
    this.layoutService.setLayout({backgroundColour: this.backgroundColour})
  }
}
